export const instruments = [
  {
    name: "Additive Synthesis Timbres",
    instruments: [
      {
        fileName: "WMRI3LST",
        name: "3-Limit (4 Harmonics)",
        gain: 0.5,
        attack: 0.5,
        release: 0.3,
        loop: true,
        velocity: true,
        velocity_floor: 0.3,
        velocity_exp: 1,
        aftertouch: 3.5,
        filter_low: 750,
        filter_mid: 1500,
        filter_high: 20000,
      },
      {
        fileName: "WMRI5LST",
        name: "5-Limit (6 Harmonics)",
        gain: 0.5,
        attack: 0.25,
        release: 0.25,
        loop: true,
        velocity: true,
        velocity_floor: 0.3,
        velocity_exp: 1,
        aftertouch: 3.5,
        filter_low: 1200,
        filter_mid: 1600,
        filter_high: 14000,
      },
      {
        fileName: "WMRI7LST",
        name: "7-Limit (10 Harmonics)",
        gain: 0.45,
        attack: 0.2,
        release: 0.2,
        loop: true,
        velocity: true,
        velocity_floor: 0.3,
        velocity_exp: 1,
        aftertouch: 3.5,
        filter_low: 1200,
        filter_mid: 1600,
        filter_high: 8000,
      },
      {
        fileName: "WMRI11LST",
        name: "11-Limit (12 Harmonics)",
        gain: 0.4,
        attack: 0.104,
        release: 0.068,
        loop: true,
        velocity: true,
        velocity_floor: 0.3,
        velocity_exp: 1,
        aftertouch: 3.5,
        filter_low: 1400,
        filter_mid: 1800,
        filter_high: 7000,
      },
      {
        fileName: "WMRI13LST",
        name: "13-Limit (16 Harmonics)",
        gain: 0.4,
        attack: 0.095,
        release: 0.085,
        loop: true,
        velocity: true,
        velocity_floor: 0.3,
        velocity_exp: 1,
        aftertouch: 3.5,
        filter_low: 1600,
        filter_mid: 2000,
        filter_high: 5000,
      },
      {
        fileName: "WMRIByzantineST",
        name: "Reed (9 Harmonics)",
        gain: 0.5,
        attack: 0.1,
        release: 0.1,
        loop: true,
        velocity: true,
        velocity_floor: 0.3,
        velocity_exp: 1,
        aftertouch: 3,
        filter_low: 2000,
        filter_mid: 2200,
        filter_high: 5000,
      },
      {
        fileName: "hammond",
        name: "Hammond (9 Harmonics)",
        gain: 0.55,
        attack: 0,
        release: 0.008,
        loop: true,
        velocity: true,
        velocity_floor: 0.6,
        velocity_exp: 0.8,
        aftertouch: 1.2,
        filter_low: 2000,
        filter_mid: 3000,
        filter_high: 20000,
      },
    ],
  },
  {
    name: "Sampled Instruments",
    instruments: [
      {
        fileName: "wurli",
        name: "Wurlitzer Electric Piano",
        gain: 0.42,
        attack: 0,
        release: 0.008,
        loop: false,
        velocity: true,
        velocity_floor: 0.18,
        velocity_exp: 1.5,
        aftertouch: 1.6,
      },
      {
        fileName: "rhodes",
        name: "Fender Rhodes",
        gain: 0.5,
        attack: 0,
        release: 0.005,
        loop: false,
        velocity: true,
        velocity_floor: 0.2,
        velocity_exp: 1.5,
        aftertouch: 1.6,
      },
      {
        fileName: "mkii",
        name: "MKII",
        gain: 0.5,
        attack: 0,
        release: 0.005,
        loop: false,
        velocity: true,
        velocity_floor: 0.18,
        velocity_exp: 1.5,
        aftertouch: 1.6,
      },
      {
        fileName: "HvP8_retuned",
        name: "Baroque Organ",
        gain: 0.53,
        attack: 0,
        release: 0.3,
        loop: true,
        loopPoints: [4.0, 5.2913, 2.287103, 4.1999, 2.287, 4.21495, 0.9711, 3.574],
        velocity: false,
        aftertouch: 0,
      },
      {
        fileName: "harpsichord",
        name: "Harpsichord",
        gain: 0.24,
        attack: 0,
        release: 1.0,
        loop: false,
        velocity: false,
        aftertouch: 0,
      },
      {
        fileName: "lute",
        name: "Lute-Stop",
        gain: 0.22,
        attack: 0,
        release: 1.2,
        loop: false,
        velocity: false,
        aftertouch: 0,
      },
      {
        fileName: "harp",
        name: "Harp",
        gain: 0.65,
        attack: 0,
        release: 4,
        loop: false,
        velocity: true,
        velocity_floor: 0.1,
        velocity_exp: 1.2,
        aftertouch: 0,
      },
      {
        fileName: "qanun",
        name: "Qanun",
        gain: 0.55,
        attack: 0,
        release: 4,
        loop: false,
        velocity: true,
        velocity_floor: 0.12,
        velocity_exp: 1.5,
        aftertouch: 0,
      },
      {
        fileName: "gayageum",
        name: "Gayageum",
        gain: 0.48,
        attack: 0,
        release: 4,
        loop: false,
        velocity: true,
        velocity_floor: 0.15,
        velocity_exp: 1.5,
        aftertouch: 1.2,
      },
      {
        fileName: "cello-viola",
        name: "Pizzicato",
        gain: 0.75,
        attack: 0,
        release: 4,
        loop: false,
        velocity: true,
        velocity_floor: 0.2,
        velocity_exp: 1.2,
        aftertouch: 0,
      },
      {
        fileName: "vibes",
        name: "Vibraphone",
        gain: 0.8,
        attack: 0,
        release: 4,
        loop: false,
        velocity: true,
        velocity_floor: 0.15,
        velocity_exp: 1.5,
        aftertouch: 1.5,
      },
      {
        fileName: "sruti",
        name: "Srutibox Harmonium",
        gain: 0.27,
        attack: 0,
        release: 0.5,
        loop: true,
        velocity: true,
        velocity_floor: 0.4,
        velocity_exp: 1.2,
        aftertouch: 4,
        filter_low: 1600,
        filter_mid: 3336,
        filter_high: 12591,
      },
    ],
  },
];
